// extracted by mini-css-extract-plugin
export default {"contentBody":"VoucherProcessStatus_contentBody__8m-Fh"};